exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".btn-toolbar a .btn{\r\n  margin-left: 5px;\r\n}", "", {"version":3,"sources":["Z:/adminlte-2-react/src/components/content/Button.css"],"names":[],"mappings":"AAAA;EACE,iBAAgB;CAClB","file":"Button.css","sourcesContent":[".btn-toolbar a .btn{\r\n  margin-left: 5px;\r\n}"],"sourceRoot":""}]);

// exports
